import {Component} from '@angular/core';
import {MxCustomizer, MxFormCustomizerEvent, OnBoFormReady} from 'mx-core';
import {FormGroup} from '@angular/forms';
import {PrlTranslateService} from '../../../../../shared/services/prl-translate.service';
import {Router} from '@angular/router';

@Component({
    selector: 'prl-add-document',
    standalone: false,
    templateUrl: './prl-add-document.component.html',
    styleUrl: './prl-add-document.component.scss',
})
export class PrlAddDocumentComponent implements MxCustomizer<MxFormCustomizerEvent>, OnBoFormReady {
    private form: FormGroup;
    private readonly parentLink = '/account';
    private readonly parentPanelId = 'documents';

    constructor(protected readonly translateService: PrlTranslateService, private readonly router: Router) {}

    boOnFormReady(form: FormGroup): void {
        this.form = form;
    }

    onCustomize(event: MxFormCustomizerEvent): void {
        event.customizeBoFormConfig({title: this.translateService.getTranslatedLabel('label.modify.account.documentation.add')})
            .customizeProps({
                addPrefixToTitle: false,
                showNavigation: true,
                customNavigation: {
                    onCancel: () => {
                        this.router.navigate([this.parentLink], {fragment: this.parentPanelId});
                    },
                    onBack: () => {
                        this.router.navigate([this.parentLink], {fragment: this.parentPanelId});
                    },
                    onSubmitRedirect: () => {
                        this.router.navigate([this.parentLink], {fragment: this.parentPanelId});
                    }
                }
            })
            .customizeFormMode('new')
            .addCustomizer(this);
    }

}
